import { Outlet } from 'react-router-dom';
import { withAuthz } from '@hakimo-ui/hakimo/util';

function TenantsRootComponent() {
  return <Outlet />;
}

export const TenantsRoot = withAuthz(TenantsRootComponent, ['tenants:view']);

export default TenantsRoot;
